import * as React from "react"
const SvgLink = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 17.143q-2.075 0-3.538-1.463Q2 14.218 2 12.143c0-2.075.487-2.563 1.462-3.538Q4.926 7.143 7 7.143h3q.424 0 .713.287.287.288.287.713c0 .425-.096.52-.287.712a.97.97 0 0 1-.713.288H7q-1.25 0-2.125.875A2.9 2.9 0 0 0 4 12.143q0 1.25.875 2.125A2.9 2.9 0 0 0 7 15.143h3q.424 0 .713.287.287.288.287.713c0 .425-.096.52-.287.712a.97.97 0 0 1-.713.288zm2-4a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h6q.424 0 .713.287.287.288.287.713c0 .425-.096.52-.287.712a.97.97 0 0 1-.713.288zm5 4a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712q0-.425.287-.713a.97.97 0 0 1 .713-.287h3q1.25 0 2.125-.875A2.9 2.9 0 0 0 20 12.143q0-1.25-.875-2.125A2.9 2.9 0 0 0 17 9.143h-3a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712q0-.425.287-.713A.97.97 0 0 1 14 7.143h3q2.075 0 3.538 1.462Q22 10.068 22 12.143c0 2.075-.488 2.562-1.462 3.537Q19.074 17.143 17 17.143z" />
  </svg>
)
export default SvgLink
